<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cBusinessOrderList' }"
          >业务订单审核</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cOrderDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>审核操作</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p>订单审核备注</p>
            <div class="input_box">
              <el-input
                v-model="formData.checknote"
                placeholder="请输入订单审核备注"
                type="textarea"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>订单审核状态</p>
            <div class="radio_box">
              <el-radio-group direction="horizontal" v-model="formData.ischeck">
                <el-radio label="0" style="margin-bottom: 20px"
                  >待审核</el-radio
                >
                <el-radio label="1">审核通过</el-radio>
                <el-radio label="2">审核不通过</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getOrderListDetail, editOrderCheck } from "../../../api/shop";
export default {
  name: "cOrderCheck",
  data() {
    return {
      loading: false,
      dataItem: "",
      formData: {
        orderno: "",
        ischeck: "",
        checknote: "",
      },
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let {orderId, orderOpenid } = JSON.parse(res.jsondata);
        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },

    // 订单列表
    getOrderListDetail(orderid,openid) {
      let params = {
        openid,
        orderid,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.formData.orderno = newObj.orderno
        this.formData.ischeck = newObj.ischeck
        this.formData.checknote = newObj.checknote
        this.loading = false;
      });
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.ischeck === "") {
        this.$message.warning("请选择退款审核状态");
        return;
      }
      this.loading = true;
      editOrderCheck(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>